module.exports = function() {
  return new Worker(__webpack_public_path__ + "9c902d5403d3fa75dce8.worker.js");
};